export default __webpack_public_path__ + "static/media/profile_img_default.f612e13c.svg";